import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/shared/components/base-modal/base-modal.component';
import { AccountModel } from '../../models/account.model';
import { AccountsService } from '../../services/accounts.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SweetAlertService } from 'src/app/shared/services/sweet-alert.service';
import { AppSettingsService } from 'src/app/shared/services/app-settings.service';
import { AccountsGeneralInfoTabComponent } from './accounts-general-info-tab/accounts-general-info-tab.component'; 
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule, NgIf } from '@angular/common';
import { UserProfileService } from 'src/app/shared/services/user-profile.service';
import { PreloaderComponent } from 'src/app/shared/components/preloader/preloader.component';
import { AccountsImageTabComponent } from './accounts-image-tab/accounts-image-tab.component';
import { TableFiltersComponent } from 'src/app/shared/components/tables/regular-table/components/table-filters/table-filters.component';


@UntilDestroy()
@Component({
    selector: 'app-accounts-modal',
    templateUrl: './accounts-modal.component.html',
    styleUrls: ['./accounts-modal.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        MatDialogModule,
        PreloaderComponent,
        AccountsGeneralInfoTabComponent,
        AccountsImageTabComponent,
        TableFiltersComponent
    ]
})

    export class AccountsModalComponent extends BaseModalComponent implements OnInit, OnDestroy {
        public currentUser = this._accountsService.currentUser;
        public loading = this._appSettingsService.isLoading;

    constructor(
        public dialogRef: MatDialogRef<AccountsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AccountModel,
        private _sweetAlertService: SweetAlertService,
        private _appSettingsService: AppSettingsService,
        private _accountsService: AccountsService,
        private _userProfileService: UserProfileService
    ) {
        super(dialogRef, _accountsService);
        this.data?.id && this._accountsService.getAccount(this.data.id, true);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.dialogRef.afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
            if (result === 'updated') {
                console.log('🔄 User updated, refreshing accounts list...');
                this._accountsService.getAccounts(); // refresh dupa inchidere dialog
            }
        });
    }

    ngOnDestroy(): void {
        this._accountsService.currentUser.set(undefined);
    }

    removeProfilePic() {
        this._sweetAlertService.showSwal('remove-picture', () => this._accountsService.removeProfileImage(this.currentUser().id), 'TheProfilePic')
    }

    save(): void {
        if (!this.data) return;

        if (this.data.self_update) {
            // Actualizare user curent
            this._userProfileService.updateUser(this.data);
            console.log('👤 Updating self user profile...');
        } else {
            // Actualizare cont din lista de conturi
            this._accountsService.updateAccount(this.data);
            console.log('👥 Updating another user account...');
        }

        this.dialogRef.close('updated');
    }
}
